import React from 'react';

/* The items (options) inside a menu */
export class MenuItem extends React.Component{
  constructor( props ){
    super( props );
    this.state = {
      name: props.name,
      item: props.item,
      afterClick: props.afterClick,
      hasError: false,
      error: {},
      info: {}
    };

    // Bindings
    this.clickedItem = this.clickedItem.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  /* Called on item being clicked */
  clickedItem(){
    // Checks to see that the callback was defined
    if( this.state.afterClick !== undefined ) {
      this.state.afterClick( this.state.item );
    }
  }


  /* Render the view for the element */
  render( ) {

    if( this.state.hasError === false ) {
      return ( <div className="selection-dropdown-menu-item" onClick={this.clickedItem}>{this.state.name}</div> );
    } else {
      return ( <span></span> );
    }

  }
}

/* The Dropdown menu to show */
export class Menu extends React.Component{
  constructor( props ){
    super( props );
    this.state = {
      options: props.selection,
      afterClick: props.selectClick,
      focus: -1,
      hasError: false,
      error: {},
      info: {}
    };

    // Bindings
    this.itemClick = this.itemClick.bind( this );
    this.getFocus = this.getFocus.bind( this );
    this.loseFocus = this.loseFocus.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  /* Sends back the item that was clicked */
  itemClick( item ){

    // Checks the call
    if( this.state.afterClick !== undefined ){
      this.state.afterClick( item );
    }
  }

  /* Gets the focus (initial hover) on menu */
  getFocus(){
    this.setState( { focus: 1} );
  }

  /* Sends back a hide menu "item" */
  loseFocus(){
    let selective = this.state.focus;

    if( selective === 1 ) {
      this.setState( {focus: 0} );
    }
    // Sends back a remove menu item
    if( this.state.afterClick !== undefined ){
      this.state.afterClick( '__unfocus_event' );
    }
  }


  onRenderMenuItems() {
    const options = this.state.options;

    if( options !== undefined ) {
      options.map( ( f ) => {
        return( <MenuItem key={f.name} name={f.name} item={f} afterClick={this.itemClick}></MenuItem> );
      } );  
    }
    return '';
  }
  /* Renders the menu (view) */
  render(){
    if( this.state.hasError === false ) {
      return (
        <div onMouseEnter={this.getFocus} onMouseLeave={this.loseFocus} className="selection-dropdown-menu">
          {this.onRenderMenuItems()}
        </div>
      );
    } else {
      return ( <span></span> );
    }
  }
}

/* Dropdown menu from button */
class SelectionDropdownButton extends React.Component{
  constructor( props ){
    super( props );

    let label;
    let options;
    let disabled;
    let style;

    // Validating the props
    // - label
    if( props.label === undefined ) {
      label = 'No label';
    } else {
      label = props.label;
    }
    // - options
    if( props.options === undefined ) {
      options = [];
    } else {
      options = props.options;
    }
    // - disabled
    if( props.isDisabled === undefined ) {
      disabled = false;
    } else {
      disabled = props.isDisabled;
    }
    // - style
    if( props.className === undefined ) {
      style = '';
    } else {
      style = props.className;
    }

    this.state = {
      render_menu: false,
      label: label,
      options: options,
      // Checked in the callback function
      onSelection: props.onSelect,
      disabled: disabled,
      style: style
    };

    // Bindings
    this.toggleMenu = this.toggleMenu.bind( this );
    this.selectItem = this.selectItem.bind( this );
  }

  /* Alters the state on new props being passed down */
  componentWillReceiveProps( nextProps ){
    this.setState( {style: nextProps.className, disabled: nextProps.isDisabled} );
  }

  /* Changes the state to toggle a menu dropdown */
  toggleMenu(){

    // If the component is disabled this takes no
    // action
    if( this.state.disabled === false ){
      let optvalue = this.state.render_menu;
      this.setState( {render_menu: !optvalue} );
    }
  }

  /* Selects a menu option and returns it back to the parent */
  selectItem( item ){

    let optvalue = this.state.render_menu;
    this.setState( {render_menu: !optvalue} );

    // Hides menu
    if( item === '__unfocus_event' ){
      this.setState( {render_menu: false} );
    } else {
      // Calling the parent function
      if( this.state.onSelection !== undefined ){
        this.state.onSelection( item );
      }
    }
  }

  // Renders a dropdown selection of available options
  render(){

    let rtype;

    if( this.state.render_menu && this.props.isDisabled === false ) {
      rtype =
        <div>
          <div className={this.state.style} onClick={this.toggleMenu}> {this.state.label} &#9660; </div>
          <Menu selection={this.state.options} selectClick={this.selectItem}></Menu>
        </div>;
    } else {
      rtype =
        <div>
          <div className={this.state.style} onClick={this.toggleMenu}> {this.state.label} &#9661; </div>
        </div>;
    }
    return(
      rtype
    );
  }
}

export default SelectionDropdownButton;



// WEBPACK FOOTER //
// ./src/presentation/SelectionDropdownButton.js